// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { getConfigFromRouterContext } from './getRequiredResourceList.tsx';
import type { RapidBoardConfig } from './TypesRapidBoardConfig.tsx';

export const getEditModel = async (boardId: string): Promise<RapidBoardConfig | null> => {
	try {
		return await fetchJson(
			`/rest/greenhopper/1.0/rapidviewconfig/editmodel.json?cardLayoutConfig=false&rapidViewId=${boardId}`,
		);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		fireErrorAnalytics({
			error,
			meta: {
				id: 'getEditModelRequest',
				packageName: 'jiraRouterResourcesClassicProjects',
				teamName: 'a4t-pandora',
			},
			sendToPrivacyUnsafeSplunk: true,
		});
		throw error;
	}
};

export const editModelResource: RouteResource<RapidBoardConfig | null> =
	createResource<RapidBoardConfig | null>({
		type: 'CLASSIC_BOARD_SETTING_EDIT_MODEL',
		getKey: (routerContext) =>
			getConfigFromRouterContext(routerContext) ? 'edit-model' : 'not-edit-model',
		getData: async (routerContext) => {
			if (getConfigFromRouterContext(routerContext)) {
				const boardId = routerContext.match.params?.boardId ?? '';
				return getEditModel(boardId);
			}
			return null;
		},
	});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getEditModelResource = (): RouteResource<any> => editModelResource;
